
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/context/auth-context";

interface StaffRouteGuardProps {
  children: React.ReactNode;
}

export const StaffRouteGuard = ({ children }: StaffRouteGuardProps) => {
  const { profile, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Allow staff, admin, tech, and superadmin roles to access protected routes
  if (!profile || (profile.role !== 'staff' && profile.role !== 'admin' && profile.role !== 'tech' && profile.role !== 'superadmin')) {
    console.log('Access denied. Current role:', profile?.role);
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
};
